import e, { Component as t } from "react";
import { componentName as n } from "../../../../utils/bem/index.js";
function o(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function r(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function i(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function l(e) {
  return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function c(e, t) {
  return (c = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
var a = function (t) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && c(e, t);
  }(f, t);
  var a,
    s,
    p,
    u = (a = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        t,
        n = l(f);
      if (a) {
        var r = l(this).constructor;
        t = Reflect.construct(n, arguments, r);
      } else t = n.apply(this, arguments);
      return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : o(this);
    });
  function f() {
    var e;
    return !function (e, t) {
      if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
    }(this, f), e = u.apply(this, arguments), i(o(e), "container", void 0), i(o(e), "body", void 0), i(o(e), "state", {
      style: {
        maxHeight: e.props.open ? "" : 0
      },
      clip: !e.props.open
    }), i(o(e), "_handleHeaderClick", function (t) {
      e.props.onHeaderClick && e.props.onHeaderClick(t);
    }), i(o(e), "_handleGlobalClick", function (t) {
      t.target.closest(".collapsible-box-header") || e._handleHeaderClick(t);
    }), i(o(e), "updateStyle", function (t) {
      e.setState({
        style: {
          maxHeight: e.props.getBodyHeight(e.body)
        }
      }, function () {
        return global.setTimeout(e._handleOpenChange.bind(o(e), t), 0);
      });
    }), i(o(e), "_handleOpenChange", function (t) {
      t.open ? e._scheduleUnclip() : e.setState({
        clip: !0,
        style: {
          maxHeight: 0
        }
      });
    }), i(o(e), "_scheduleUnclip", function () {
      global.setTimeout(function () {
        return e.setState({
          clip: !1,
          style: {
            maxHeight: ""
          }
        });
      }, 500);
    }), i(o(e), "_receiveContainer", function (t) {
      return e.container = t;
    }), i(o(e), "_receiveBody", function (t) {
      return e.body = t;
    }), e;
  }
  return s = [{
    key: "componentWillUnmount",
    value: function value() {
      window.removeEventListener("click", this._handleGlobalClick, !0);
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e) {
      e.open !== this.props.open && (this.updateStyle(this.props), this.props.open ? (window.addEventListener("click", this._handleGlobalClick, !0), this.props.onOpen && this.props.onOpen()) : (window.removeEventListener("click", this._handleGlobalClick, !0), this.props.onClose && this.props.onClose()));
    }
  }, {
    key: "render",
    value: function value() {
      var t = this.props,
        o = t.className,
        r = t.open,
        i = n("collapsible-box", o, {
          clip: this.state.clip,
          open: r
        });
      return e.createElement("div", {
        ref: this._receiveContainer,
        className: i
      }, e.createElement("div", {
        className: "collapsible-box-header",
        onClick: this._handleHeaderClick
      }, this.props.header), e.createElement("div", {
        className: "collapsible-box-body",
        style: this.state.style,
        ref: this._receiveBody
      }, this.props.children));
    }
  }], r(f.prototype, s), p && r(f, p), f;
}(t);
i(a, "defaultProps", {
  getBodyHeight: function getBodyHeight(e) {
    return (null == e ? void 0 : e.scrollHeight) || 0;
  }
});
export { a as CollapsibleBoxOnClick };